export const USER_LOAD_PREFERENCES_SUCCESS = 'USER_LOAD_PREFERENCES_SUCCESS';
export const USER_LOAD_PREFERENCES_FAILURE = 'USER_LOAD_PREFERENCES_FAILURE';
export const USER_SAVE_PREFERENCES_SUCCESS = 'USER_SAVE_PREFERENCES_SUCCESS';
export const USER_SAVE_PREFERENCES_FAILURE = 'USER_SAVE_PREFERENCES_FAILURE';
